import React, { useState } from "react";
import Button from "@mui/material/Button";
import AuditDialog from "./auditDialog";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";

const AuditButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleButtonClick = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <Button sx={{backgroundColor:"#2b8818", '&:hover': { backgroundColor: "#2b8818" }, padding : {xs:"8px 8px", md:"8px 16px"} }}
        variant="contained"
        size="small"
        onClick={handleButtonClick}
      >
        <ManageSearchIcon sx={{ mr: "2.5px" }} />
        Audit
      </Button>
      {isOpen && (
        <div style={{ position: "absolute", top: "100%", left: 0 }}>
          <AuditDialog isOpen={isOpen} onClose={handleClose} />
        </div>
      )}
    </div>
  );
};

export default AuditButton;
